import { ThunkAction } from '@reduxjs/toolkit';
import { hasKey } from 'features/sport';
import { RootState } from 'lib/centralStore';
import { isSnaiSite } from 'utility/constant';
import { CarrelloActions, TicketErroreSistema } from '../types';
import { getSliceByTipoTicket } from '../utils';

export const updatePuntataSistema =
  (
    puntataInputValue: number,
    sistema: boolean,
    idSistema: string,
    isPlain = false
  ): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    if (sistema && idSistema) {
      const tipo = getState().carrello.tipo;
      const { name: sliceName, actions } = getSliceByTipoTicket(tipo);
      const erroriSistema = getState()[sliceName];

      dispatch(
        actions.puntataSingolaMultiplaUpdated(!isSnaiSite ? Number(puntataInputValue.toFixed(2)) : puntataInputValue)
      );
      dispatch(
        actions.puntataPerScommesseSistemaUpdated({
          idSistema,
          puntata: puntataInputValue,
          isPlain,
        })
      );

      if (hasKey(erroriSistema, [idSistema])) {
        dispatch(
          actions.erroriSistemiRemoved({
            idSistema,
            errore: TicketErroreSistema.IncrementoImportoSistemaNonCorretto,
          })
        );
      }

      dispatch(actions.isScommettibileToggled(true));
    }
  };

export const updateErroriSistemiAdded =
  (idSistema: string, erroreSistema: TicketErroreSistema): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    const tipo = getState().carrello.tipo;
    const { actions } = getSliceByTipoTicket(tipo);
    dispatch(actions.erroriSistemiAdded({ idSistema, errore: erroreSistema }));
    dispatch(actions.isScommettibileToggled(false));
  };
